import { useMutation } from "react-query";
import {
  storeOnboarding,
  sendOnboarding,
  returnValidationOnboarding,
  closeVersionOnboarding,
} from "../../../../../services/vmApi";

export function useSaveOnboarding(options) {
  return useMutation(data => storeOnboarding(data), options);
}

export function useSendOnboarding(options) {
  return useMutation(data => sendOnboarding(data), options);
}

export function useReturnValidationOnboarding(options) {
  return useMutation(data => returnValidationOnboarding(data), options);
}

export function useCloseVersionOnboarding(options) {
  return useMutation(data => closeVersionOnboarding(data), options);
}
